import React from 'react';
import { ShieldCheck, Lock, CreditCard } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function Hero() {
  return <section className="bg-white text-slate-900 pt-8 pb-8 px-4 md:pt-16 md:pb-16 overflow-hidden relative" data-id="element-165">
      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-166">
        <div className="animate-fadeInUp" data-id="element-167">
          <div className="inline-block bg-[#C8A96B]/10 text-[#C8A96B] px-4 py-1.5 rounded-full text-[10px] font-bold mb-8 border border-[#C8A96B]/20 tracking-widest uppercase" data-id="element-168">
            ✨ MÉTODO TÉCNICO PROFESIONAL PARA ESTILISTAS, COLORISTAS Y
            PELUQUEROS.
          </div>

          <h1 className="md:text-6xl lg:text-7xl font-extrabold mb-8 px-0 text-slate-900 text-[20px]" data-id="element-169">
            💥 DEJÁ DE IMPROVISAR COLOR Y EMPEZÁ A{' '}
            <span className="bg-gradient-to-r from-[#C8A96B] via-[#D4BD8B] to-[#C8A96B] bg-clip-text text-transparent" data-id="element-170">
              FORMULAR COMO PROFESIONAL.
            </span>
          </h1>

          <div className="relative mb-6 max-w-2xl mx-auto" data-id="element-171">
            <div className="absolute inset-0 bg-brand-gold/5 blur-[100px] rounded-full scale-75 pointer-events-none" data-id="element-172" />
            <img src="https://cdn.magicpatterns.com/uploads/secB7CaZm9iFJMMpe8DgNF/MOCKUP_600x.png" alt="MegaPack Colorimetría Pro" fetchPriority="high" loading="eager" width="600" height="450" decoding="async" className="w-full h-auto drop-shadow-[0_20px_50px_rgba(0,0,0,0.1)] mockup-glow relative z-10" data-id="element-173" />
          </div>

          <p className="md:text-xl font-medium mb-6 max-w-2xl mx-auto text-slate-600 text-[14px]" data-id="element-174">
            Sistema completo con guías, fórmulas y herramientas listas para
            aplicar desde hoy.
          </p>

          <CTAButton text="QUIERO ACCESO INMEDIATO" className="w-auto mx-auto mb-6 shadow-xl shadow-[#C8A96B]/20" data-id="element-175" />

          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-xs md:text-sm text-slate-400 font-medium" data-id="element-176">
            <div className="flex items-center gap-2" data-id="element-177">
              <ShieldCheck size={18} className="text-brand-gold" data-id="element-178" />
              <span data-id="element-179">Garantía 7 días </span>
            </div>
            <div className="flex items-center gap-2" data-id="element-180">
              <Lock size={18} className="text-brand-gold" data-id="element-181" />
              <span data-id="element-182">Pago 100% seguro</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-183">
              <CreditCard size={18} className="text-brand-gold" data-id="element-184" />
              <span data-id="element-185">Pagás en pesos argentinos</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}